import React from 'react';

import Button from '@/components/Button/Button';
import { useFormatText } from '@/hooks/useFormatText';

interface ITablePaginationProps {
  total: number;
  currentPage: number;
  pageSize: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  isLoading?: boolean;
  className?: string;
  dataTestId?: string;
}

const Pagination = ({
  total,
  currentPage,
  pageSize,
  setCurrentPage,
  isLoading = false,
  className = '',
  dataTestId = 'pagination',
}: ITablePaginationProps) => {
  const { formatText } = useFormatText();

  return (
    <div
      className={`bg-white border-t border-neutral-200 px-4 py-3 flex justify-between items-center z-10 ${className}`}
      data-testid={dataTestId}
    >
      <p className="text-neutral-primary text-sm font-medium text-nowrap">
        {formatText('common.table.showing')}{' '}
        {total === 0 ? 0 : (currentPage - 1) * pageSize + 1} -{' '}
        {Math.min(currentPage * pageSize, total ?? 0)}{' '}
        {formatText('common.table.of')} {total}{' '}
        {formatText('common.table.entries')}
      </p>
      <div className="flex gap-3">
        <Button
          variant="outline"
          label={formatText('common.table.previous')}
          className="px-4 h-10 min-w-25"
          onClick={() => setCurrentPage?.((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1 || isLoading}
        />
        <Button
          variant="outline"
          label={formatText('common.table.next')}
          className="px-4 h-10 min-w-25"
          onClick={() =>
            setCurrentPage?.((prev) =>
              Math.min(prev + 1, Math.ceil((total ?? 0) / pageSize))
            )
          }
          disabled={
            currentPage >= Math.ceil((total ?? 0) / pageSize) || isLoading
          }
        />
      </div>
    </div>
  );
};

export default Pagination;
